import { AxiosResponse } from 'axios';
import api from './Api'

export const getEventCouponAvailableByCodeAndTicket = (code: string, wellnessTicketId: string): Promise<AxiosResponse<IEventCoupon, any>> => {
    return api.get(`/mobile/eventCoupon/${code}/${wellnessTicketId}`);
}

export const checkEventCouponAvailableByCodeAndTicket = (code: string, wellnessTicketId: string): Promise<AxiosResponse<IEventCoupon, any>> => {
    return api.get(`/mobile/eventCoupon/check/${code}/${wellnessTicketId}`);
}